import Vue from 'vue'
import Vuex from 'vuex'
import api from "@/http/electrician/api.js";
import { ProvinceList } from "@/http/factory/add-eme.js";
Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		name: window.localStorage.getItem("name"),
		account: window.localStorage.getItem("account"),
		token: window.localStorage.getItem("token"),
		avatar: window.localStorage.getItem("avatar"),
		userType: window.localStorage.getItem("userType"),
		local: '',
		needStatus: [
			{
				label: "全部",
				value: ''
			},{
				label: "待发布",
				value: '-1'
			},{
				label: "已发布",
				value: '0'
			}, {
				label: "结束招工",
				value: '1'
			}, {
				label: "结算单确认",
				value: '2'
			}, {
				label: "待结算",
				value: '5'
			}, {
				label: "待收款",
				value: '6'
			}, {
				label: "确认收款",
				value: '7'
			}, {
				label: "完结",
				value: '8'
			},
		],
		orderStatus: [
			{
				label: '全部',
				value: ''
			}, {
				label: '待审核',
				value: '1'
			}, {
				label: '待结算',
				value: '2'
			}, {
				label: '结算单确认',
				value: '3'
			}, {
				label: '待收款',
				value: '5'
			}, {
				label: '完结',
				value: '6'
			},
		],
		electicianType: [],
		regionList: []
	},
	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_NAME: (state, name) => {
			state.name = name
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar
		},
		SET_ACCOUNT: (state, phone) => {
			state.account = phone
		},
		SET_USER_TYPE: (state, userType) => {
			state.userType = userType
		},
		SET_electicianType: (state, electicianType) => {
			state.electicianType = electicianType
		},
		SET_regionList: (state, regionList) => {
			state.regionList = regionList
		}
	},
	actions: {
		// 登录
		Login({ commit }, userInfo) {
			window.localStorage.setItem("token", userInfo.token);
			window.localStorage.setItem("name", userInfo.name);
			window.localStorage.setItem("account", userInfo.phone);
			window.localStorage.setItem("avatar", userInfo.headimg);
			window.localStorage.setItem("userType", userInfo.userType);
			commit('SET_TOKEN', userInfo.token);
			commit('SET_NAME', userInfo.name);
			commit('SET_AVATAR', userInfo.headimg);
			commit('SET_ACCOUNT', userInfo.phone);
			commit('SET_USER_TYPE', userInfo.userType)
		},
		// 退出系统
		LogOut({ commit, state }, $router) {
			window.localStorage.clear()
			commit('SET_TOKEN', null)
			commit('SET_NAME', null)
			commit('SET_AVATAR', null)
			commit('SET_ACCOUNT', null)
			commit('SET_USER_TYPE', null)
			$router.push({
				path: '/'
			})
		},
		// 获取 电工类型
		async getElecticianType({ commit, state }) {
			if(state.electicianType.length == 0){
				const data = await api.electrician_type();
				if(data){
					commit('SET_electicianType',data);
				}
			}
		},
		// 获取 省市区 三级
		async getRegionList({ commit, state }) {
			if(state.regionList.length == 0){
				const data  = await ProvinceList();
				if(data){
					commit('SET_regionList',data);
				}
			}
		},
	},
	getters:{
		needStatus: (state) => state.needStatus,
		orderStatus: (state) => state.orderStatus,
		electicianType: (state) => state.electicianType,
		regionList: (state) => state.regionList,
	}
})
